import { QueryClient } from '@tanstack/react-query'

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000 // The duration until a query transitions from fresh to stale. default is: instantly
      // cacheTime: Infinity // The duration until inactive queries will be removed from the cache. default is: 5 minutes
    }
  }
})

export default queryClient
